<template>
  <main class="main home-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <h1>
            <div class="title title-42">Your Gateway to</div>
            <div class="title title-92">Survival Adventures</div>
          </h1>
        </div>
      </div>
      <div class="section section-welcome">
        <div class="wrapper">
          <div class="title title-32">Welcome to</div>
          <div class="title title-52">
            Mineref<span class="orange">Craft</span>
          </div>
          <div class="desc big">
            a unique Minecraft server where you'll face tough challenges, hardcore modes, and a world designed for true survivalists! There's no room for boredom here – only your mind, skills, and adaptability will help you survive and thrive.
          </div>
          <button @click="copyIp" class="button">{{ipCopied ? 'IP copied' : 'Join server'}}</button>
        </div>
      </div>
      <div class="section section-unique">
        <div class="wrapper">
          <div class="title title-92 title-main">
            What makes us <span class="orange">unique?</span>
          </div>
          <div class="list">
            <div class="item">
              <div class="left">
                <img src="./../img/bg1.webp" class="img"/>
              </div>
              <div class="right">
                <div class="text">
                  <div class="title title-24">Hardcore Survival:</div>
                  <div class="desc desc-18">A level of difficulty that will make you think about every move. Stronger monsters, limited resources, and weather that can become your worst enemy.</div>
                </div>
                <div class="text">
                  <div class="title title-24">Unique Biomes:</div>
                  <div class="desc desc-18">Explore captivating new territories with rare resources and mysterious secrets.</div>
                </div>
                <div class="text">
                  <div class="title title-24">Custom Mods:</div>
                  <div class="desc desc-18">Exclusive mechanics and items designed specifically for our server. Forget standard gameplay; this is a whole new level!</div>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="right">
                <div class="text">
                  <div class="title title-24">Competitions:</div>
                  <div class="desc desc-18">Join weekly events to showcase your skills and earn rare rewards.</div>
                </div>
                <div class="text">
                  <div class="title title-24">Survival Community:</div>
                  <div class="desc desc-18">Find allies or rivals among other players. In this world, every encounter is a choice between friendship and conflict.</div>
                </div>
              </div>
              <div class="left">
                <img src="./../img/bg2.webp" class="img"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Pack Section -->
      <PackSection @addToCart="addPackToCart" :currency="$parent.currency" :currencyCode="$parent.currencyCode" />
      
      <div class="section section-try">
        <div class="wrapper">
          <div class="title title-52">
            Mineref<span class="orange">Craft</span> <span>-</span>
          </div> 
          <div class="title title-32">
            <span class="gray">not everyone can survive,</span>
            but everyone must try!
          </div>
          <div class="desc desc-18 gray">Start your adventure now! Create your strategy, build your base, hunt, gather resources, and test yourself in extreme conditions.</div>
          <button @click="copyIp" class="button">{{ipCopied ? 'IP copied' : 'Join server'}}</button>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import PackSection from '@/components/pack/PackSection.vue';

export default {
  name: 'Home',
  props: [],
  components: {
    PackSection
  },
  data: function() {
    return {
      email: '',
      name: '',
      message: '',
      nickname: '',
      activePanels: [],
      faq: [
        {
          title: 'SERVER ACCESS',
          content: 'Our server is free to play, and we also have an in-game items store to enhance your gaming experience.'
        },
        {
          title: 'LOGGING INTO THE SERVER',
          content: 'To log in to our game server, you need to install a licensed copy of Minecraft on your computer. Once installed, input our server IP address, which is 145.223.98.116:25565, into the server launcher, and click "Join" to start playing.'
        },
        {
          title: 'BUYING PRODUCTS',
          content: 'To purchase products, simply enter your nickname in the form provided and click on the "products" button.'
        },
        {
          title: 'CONTACT US',
          content: 'If you have any questions or concerns, please don\'t hesitate to contact us via email support@craft-ify.com or through our social media channels.'
        }
      ],
      ipCopied: false
    }
  },
  mounted() {
  },
  methods: {
    copyIp() {
      let self = this;
      var textarea = document.createElement("textarea");
      textarea.value = self.$parent.ip;
      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand("copy");

      document.body.removeChild(textarea);
      self.ipCopied = true;
      
      setTimeout(()=> {
        self.ipCopied = false;
      }, 2000)
    },
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1)
      } else {
        this.activePanels.push(index)
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index)
    },
    submit() {
      let data = {
        "name": this.name,
        "email": this.email,
        "message": this.message
      }
      this.$emit('sendContactForm', data);
    },
    addPackToCart(pack, id, quantity, itemType) {
      this.$parent.addToCart(pack, id, quantity, itemType);
    }
  }
}
</script>